import React from 'react'
import './style.scss'
import { Icon } from 'react-icons-kit'
import { Modal } from 'react-bootstrap'
import { lock, phoneOutgoing, messageCircle, send, x, zap } from 'react-icons-kit/feather'
import { Link } from 'react-router-dom'

const ContactInfo = (props) => {

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            dialogClassName="custom-settings-modal sp-modal"
            backdrop="static"
            keyboard={false}
            centered
        >
            <div className="sp-modal-head">
                <span className="sp-modal-icon"><Icon icon={lock} size={18} /></span>
                <div className="sp-modal-head-text">
                    <h6>Unlock contact details</h6>
                    <p>Available with a paid membership</p>
                </div>
                <button type="button" className="sp-modal-close" onClick={props.onHide} aria-label="Close">
                    <Icon icon={x} size={18} />
                </button>
            </div>

            <div className="sp-modal-body">
                <p className="sp-modal-lead">
                    Upgrade your membership to reach out to this member directly.
                </p>

                <ul className="sp-modal-list">
                    <li>
                        <span className="sp-modal-li-icon"><Icon icon={phoneOutgoing} size={16} /></span>
                        <div>
                            <h6>Direct call</h6>
                            <p>View the contact number and call instantly.</p>
                        </div>
                    </li>
                    <li>
                        <span className="sp-modal-li-icon"><Icon icon={messageCircle} size={16} /></span>
                        <div>
                            <h6>WhatsApp</h6>
                            <p>Start a conversation on WhatsApp.</p>
                        </div>
                    </li>
                    <li>
                        <span className="sp-modal-li-icon"><Icon icon={send} size={16} /></span>
                        <div>
                            <h6>Instant chat</h6>
                            <p>Chat inside matchmaking service without sharing numbers.</p>
                        </div>
                    </li>
                </ul>

                <Link to="/my-dashboard/package" className="sp-modal-btn sp-modal-btn-upgrade">
                    <Icon icon={zap} size={15} /> View plans
                </Link>
            </div>
        </Modal>
    )
}

export default ContactInfo
